module.exports = __webpack_public_path__ + "img/qt.1727dce9.svg";